module.exports = __webpack_public_path__ + "static/media/inf_86og87.0db23185.mp3";